import script from "./CompanyDetailView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanyDetailView.vue?vue&type=script&lang=ts&setup=true"

import "./CompanyDetailView.vue?vue&type=style&index=0&id=1da058f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da058f7"]])

export default __exports__